export enum AccountType {
    JobSeeker = "JOB_SEEKER",
    Employer = "EMPLOYER",
    Referrer = "REFERRER",
    Admin = "ADMIN"
}

export enum ThreadType {
    Direct = "DIRECT",
    Referral = "REFERRAL"
}

export enum ReferralRequestStatus {
    NEW = "NEW",
    IN_PROGRESS = "IN_PROGRESS",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
    EXPIRED = "EXPIRED"
}

export enum OfferTypes {
    NEW_OFFER = "New Offer",
    EMPLOYEE = "Employee"
}

export enum LOCALSTORAGEKEYS {
    USER = "user"
}
